export async function startStatsigSessionReplay(client, options = {}) {
    const { runStatsigSessionReplay } = await import("@statsig/session-replay");
    runStatsigSessionReplay(client, options);
}
